import React, { useState, useEffect } from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import Header from '../components/Header';
import Footer from '../components/Footer';

const CancelPage = () => {
  const [cart, setCart] = useState([]);

  // Fetch cart using Stripe session ID
  const restoreCartFromSession = async (sessionId) => {
    try {
      const res = await fetch(`/api/cart-session/${sessionId}`);
      const data = await res.json();

      if (data.success && Array.isArray(data.cart)) {
        setCart(data.cart);
        localStorage.setItem("cart", JSON.stringify(data.cart));
        console.log("set cart: ", data.cart)
      } else {
        console.warn("No cart returned for session:", sessionId);
      }
    } catch (err) {
      console.error("Failed to restore cart from session:", err);
    }
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const sessionId = urlParams.get('session_id');

    if (sessionId) {
      restoreCartFromSession(sessionId);
    } else {
      const savedCart = localStorage.getItem("cart");
      setCart(savedCart ? JSON.parse(savedCart) : []);
    }
  }, []);

  const navLinks = [
    { text: "TOUR", link: "/#upcoming" },
    { text: "STREAM", link: "/#stream" },
    { text: "RELEASES", link: "/#releases" },
    { text: "SHOP", link: "/#boutique", external: true },
    { text: "ABOUT", link: "/#about" },
  ];

  return (
    <>
      <Header menuItems={navLinks} cartQty={cart?.length || 0} />

      <Box
        sx={{
          backgroundImage: `url(/images/rainbow_bg.jpg)`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "100% 100%",
          backgroundAttachment: "fixed",
          backgroundPosition: "center bottom",
          minHeight: "100vh",
          display: 'flex',
          alignItems: 'center',
          py: 4,
        }}
      >
        <Container 
          maxWidth="sm" 
          sx={{ 
            bgcolor: "white", 
            opacity: 0.95, 
            p: 5, 
            borderRadius: 2,
            textAlign: 'center'
          }}
        >
          <CancelOutlinedIcon 
            sx={{ fontSize: 80, color: 'warning.main', mb: 2 }} 
          />
          
          <Typography variant="h4" gutterBottom>
            <strong>Payment Cancelled</strong>
          </Typography>
          
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Your payment was cancelled. Your cart has been restored and you can complete your purchase anytime.
          </Typography>
          
          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', mt: 4 }}>
            <Button 
              variant="contained" 
              color="primary"
              onClick={() => window.location.href = '/shopping-cart'}
            >
              Return to Cart
            </Button>
            
            <Button 
              variant="outlined" 
              color="primary"
              onClick={() => window.location.href = '/'}
            >
              Back to Home
            </Button>
          </Box>
        </Container>
      </Box>

      <Footer />
    </>
  );
};

export default CancelPage;
